import { EnvKey } from "../constants";

export const EnvHelper = {
  getValue(key: EnvKey): string {
    if (!key) return "";
    return process.env[key] as string;
  },
};
